var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import ActionDialogLayout from '@/views/Groups/Tabs/Actions/Dialogs/ActionDialogLayout/ActionDialogLayout.vue';
import { Group } from '@/models/Group';
import SubjectLevelSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/SubjectLevelSelector/SubjectLevelSelector.vue';
import StudentSelector from '@/views/Groups/Tabs/Actions/Dialogs/Selectors/StudentSelector/StudentSelector.vue';
import LabelValue from '@/components/LabelValue.vue';
import ErrorHandler from '@/support/ErrorHandler';
import axios from 'axios';
import { identifyApplication, identifyHostname, isLocal } from '@/support/Client';
import { Token } from '@/support/Token';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import { sortByKey } from '@/support/Object';
import StatusFilter from '@/components/SummaryFilters/StatusFilter/StatusFilter.vue';
import { LabelGroup } from '@/models/LabelGroup';
import { LabelKey } from '@/models/Label';
let DownloadPlpDialog = class DownloadPlpDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedStudents = {};
        this.selectedSubjects = [];
        this.selectedSubjectsToIncludeSteps = [];
        this.selectedStatuses = [];
        this.message = '';
        this.isDownloaded = false;
        this.isLoading = false;
        this.currentStep = 1;
        this.selectedProject = null;
        this.isSelectAll = true;
        this.isSelectAllToIncludeSteps = true;
        this.curriculum = new CurriculumModel();
        this.LabelKey = LabelKey;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.fetchCurriculum();
        await this.fetchStatuses();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onReset() {
        this.selectedStudents = {};
        this.selectedSubjects = [];
        this.isSelectAll = true;
        this.currentStep = 1;
        this.isDownloaded = false;
        this.isLoading = false;
        this.message = '';
    }
    onClose() {
        this.$emit('close');
    }
    onSelectedStudents(value) {
        this.$set(this, 'selectedStudents', value);
    }
    onCurrentStepChanged(value) {
        this.currentStep = value;
    }
    toggleSelectAllToIncludeSteps(value) {
        if (!value) {
            this.selectedSubjectsToIncludeSteps = [];
            return;
        }
        this.selectAllToIncludeSteps();
    }
    selectAllToIncludeSteps() {
        if (!this.selectedSubjects || !this.selectedSubjects.length) {
            return;
        }
        this.selectedSubjectsToIncludeSteps = this.selectedSubjects.map((subject) => {
            return subject.id || '';
        });
    }
    toggleSelectAll(value) {
        if (!value) {
            this.selectedSubjects = [];
            return;
        }
        this.selectAll();
    }
    selectAll() {
        if (!this.curriculum || !this.curriculum.subjects) {
            return;
        }
        this.selectedSubjects = this.curriculum.subjects.map((subject) => {
            return subject;
        });
    }
    // #endregion
    // #region Async methods (api calls only)
    async fetchStatuses() {
        try {
            const statusSets = await new LabelGroup().all();
            const statuses = statusSets[0].labels.map((label) => label.key) || [];
            this.selectedStatuses = statuses.filter((label) => {
                return label !== LabelKey.FUTURE && label !== LabelKey.INACTIVE; // Exclude 'future' and 'inactive' statuses for download
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async fetchCurriculum() {
        this.curriculum
            .current()
            .include(['children', 'subjects'])
            .first()
            .then((curriculum) => {
            this.curriculum = curriculum;
            const areas = this.curriculum.subjects || [];
            areas.forEach((area, index) => {
                this.curriculum.subjects[index] = this.curriculum.dataToModel(area, 'Subject');
                const topics = this.curriculum.subjects[index].children || [];
                topics.forEach((topic, i) => {
                    this.curriculum.subjects[index].children[i] = this.curriculum.dataToModel(topic, 'Subject');
                });
                topics.sort(sortByKey('name'));
                this.$set(this.curriculum.subjects[index], 'children', topics);
            });
            areas.sort(sortByKey('name'));
            this.$set(this.curriculum.subjects, 'subjects', areas);
        });
    }
    create() {
        this.downloadFileBlob();
    }
    async downloadFileBlob() {
        this.isLoading = true;
        const API = `${identifyHostname()}`;
        const headers = {
            'Accept': 'application/pdf',
            'Content-type': 'application/json',
        };
        if (isLocal()) {
            headers['X-Application'] = identifyApplication();
        }
        if (Token.getAccessToken()) {
            headers.Authorization = `Bearer ${Token.getAccessToken()}`;
        }
        const client = axios.create({
            baseURL: API,
            headers,
        });
        let url = `/v3/student-idp-download/?with[]=parent&with[]=area&with[]=level&with[]=period&with[]=template`;
        if (Object.keys(this.selectedStudents).length) {
            const studentIds = Object.keys(this.selectedStudents);
            const students = [];
            studentIds.forEach((studentId) => {
                students.push(`&filters[users][]=${studentId}`);
            });
            url = `${url}${students.join('')}`;
        }
        if (this.selectedSubjects.length) {
            const areas = [];
            this.selectedSubjects.forEach((subject) => {
                areas.push(`&filters[areas][]=${subject.id}`);
            });
            url = `${url}${areas.join('')}`;
        }
        if (this.selectedStatuses.length) {
            const statuses = [];
            this.selectedStatuses.forEach((status) => {
                statuses.push(`&filters[statuses][]=${status}`);
            });
            url = `${url}${statuses.join('')}`;
        }
        if (this.selectedSubjectsToIncludeSteps.length) {
            const selectedSubjects = [];
            this.selectedSubjectsToIncludeSteps.forEach((subject) => {
                selectedSubjects.push(`&filters[steps][]=${subject}`);
            });
            url = `${url}${selectedSubjects.join('')}`;
        }
        try {
            await client.get(url).then((response) => {
                this.message = this.$t(`${response.data.message}`).toString();
                this.isDownloaded = true;
                this.isLoading = false;
                this.onReset();
                this.$emit('submitted');
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    // #endregion
    // #region Getters & Setters
    get isDisabled() {
        switch (this.currentStep) {
            case 1:
                return (Object.keys(this.selectedStudents).every((key) => {
                    return this.selectedStudents[key] === false;
                }) || Object.keys(this.selectedStudents).length === 0);
            case 2:
                return !this.selectedSubjects || this.selectedSubjects.length === 0;
            case 3:
            case 4:
                return false;
            default:
                return false;
        }
    }
    get selectAllSubjectsToIncludeSteps() {
        if (!this.selectedSubjects || !this.selectedSubjects.length) {
            return false;
        }
        if (this.selectedSubjectsToIncludeSteps.length !== this.selectedSubjects.length) {
            return false;
        }
        return this.isSelectAllToIncludeSteps;
    }
    set selectAllSubjectsToIncludeSteps(value) {
        if (!this.selectedSubjects || !this.selectedSubjects.length) {
            return;
        }
        if (this.selectedSubjectsToIncludeSteps.length === this.selectedSubjects.length) {
            this.isSelectAllToIncludeSteps = true;
            return;
        }
        this.isSelectAllToIncludeSteps = value;
    }
    get selectAllSubjects() {
        if (!this.curriculum || !this.curriculum.subjects) {
            return false;
        }
        if (this.selectedSubjects.length !== this.curriculum.subjects.length) {
            return false;
        }
        return this.isSelectAll;
    }
    set selectAllSubjects(value) {
        if (!this.curriculum || !this.curriculum.subjects) {
            return;
        }
        if (this.selectedSubjects.length === this.curriculum.subjects.length) {
            this.isSelectAll = true;
            return;
        }
        this.isSelectAll = value;
    }
    get projects() {
        if (this.group && this.group.projects) {
            return [this.group.projects];
        }
        return [];
    }
    get dialogDescription() {
        return this.$tc('It can take up to 7 or 10 minutes to receive the downloaded items in your mailbox. If not, double check you SPAM folder or the helpdesk.');
    }
    get dialogOptions() {
        return {
            steps: [
                { label: this.$tc('Select students'), value: 1 },
                { label: this.$tc('Select PLP'), value: 2 },
                { label: this.$tc('Select statuses'), value: 3 },
                { label: this.$tc('Include steps'), value: 4 },
            ],
            title: this.$tc('downloadDialog.header.title'),
            description: this.dialogDescription,
            isLoading: this.isLoading,
            customButtons: [
                {
                    label: this.$tc('Download'),
                    icon: 'download',
                    color: 'primary',
                    visible: this.currentStep === 4,
                    disabled: this.isDisabled,
                    action: () => {
                        this.create();
                    },
                },
            ],
        };
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], DownloadPlpDialog.prototype, "group", void 0);
DownloadPlpDialog = __decorate([
    Component({
        components: {
            ActionDialogLayout,
            SubjectLevelSelector,
            StudentSelector,
            LabelValue,
            StatusFilter,
        },
    })
], DownloadPlpDialog);
export default DownloadPlpDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
